var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('v-main',[(_vm.returningFromAuth && _vm.loadingSilent)?_c('loading-card'):(_vm.logged)?_c('div',[_c('active-view')],1):_c('SolidLogin')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }